import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CTASection: React.FC = () => {
  const navigate = useNavigate();

  const handleDiagnostic = () => navigate('/diagnostic');

  return (
    <section
      className="section-lg relative overflow-hidden"
      style={{ background: 'hsl(var(--dark))' }}
    >

      {/* ── Atmospheric depth ───────────────────────────── */}
      {/* Radial rose glow — upper left */}
      <div
        className="absolute pointer-events-none"
        style={{
          top: '-10%',
          left: '-5%',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, hsl(var(--rose) / 0.1) 0%, transparent 65%)',
        }}
      />
      {/* Lilas glow — bottom right */}
      <div
        className="absolute pointer-events-none"
        style={{
          bottom: '-15%',
          right: '-8%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, hsl(var(--lilas) / 0.08) 0%, transparent 65%)',
        }}
      />

      {/* Decorative large italic watermark */}
      <div
        className="absolute bottom-0 right-0 font-display font-semibold pointer-events-none select-none translate-x-[15%] translate-y-[20%]"
        style={{
          fontSize: 'clamp(10rem, 25vw, 20rem)',
          lineHeight: 1,
          fontStyle: 'italic',
          color: 'hsl(var(--white) / 0.025)',
          letterSpacing: '-0.04em',
        }}
      >
        Glow
      </div>

      {/* ── Content ─────────────────────────────────────── */}
      <div className="container mx-auto px-4 text-center content-medium relative z-10">
        <div className="reveal">

          {/* Rose line accent */}
          <div
            className="reveal-child w-10 h-px mx-auto mb-8"
            style={{ background: 'hsl(var(--rose))' }}
          />

          {/* Headline */}
          <h2
            className="reveal-child font-display mb-8 leading-[1.08]"
            style={{
              fontSize: 'clamp(2rem, 5.5vw, 3.75rem)',
              color: 'hsl(var(--white))',
            }}
          >
            Prête à passer de
            <br className="hidden sm:block" />
            <span style={{ color: 'hsl(var(--white) / 0.75)' }}>« je poste »</span> à{' '}
            <span
              className="font-medium"
              style={{ fontStyle: 'italic', color: 'hsl(var(--rose))' }}
            >
              « je vends »
            </span>{' '}
            ?
          </h2>

          {/* Subtitle */}
          <p
            className="reveal-child text-lg mb-10 max-w-xl mx-auto leading-relaxed"
            style={{ color: 'hsl(var(--white) / 0.75)' }}
          >
            Réserve ton Diagnostic Stratégique.
            <br />
            En 2 heures, on identifie exactement ce qui bloque ta croissance et comment le débloquer.
          </p>

          {/* CTA button */}
          <button
            onClick={handleDiagnostic}
            className="reveal-child group w-full sm:w-auto font-semibold text-base px-9 py-4 rounded-xl transition-all duration-300 inline-flex items-center justify-center gap-2.5 hover:scale-[1.02]"
            style={{
              background: 'hsl(var(--rose))',
              color: 'hsl(var(--white))',
              boxShadow: '0 4px 30px rgba(212, 100, 154, 0.4)',
            }}
          >
            Réserver mon Diagnostic — 590€
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>

          {/* Scarcity note */}
          <p
            className="reveal-child text-sm mt-8"
            style={{ color: 'hsl(var(--white) / 0.55)' }}
          >
            Places limitées à 3 diagnostics par mois.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
